import React, { useContext, useEffect, useState } from "react";
import { Alert, Table } from "../../layout";
import { Avatar, IconButton, Tooltip } from "@mui/material";
import {
  ClearRounded,
  EditRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Button } from "../../controls";
import { AppContext } from "../../App";
import { API, action, controller } from "../../api/api";
import { useFormatPrice } from "hooks";

const Customers = () => {
  const formatPrice = useFormatPrice();
  const { access } = useContext(AppContext);
  const navigate = useNavigate();
  const { setLoader } = useContext(AppContext);
  const [cstmrs, setCstmrs] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setLoader(true);
    API(controller.Customer + action.GetAllByOrg).get((res) => {
      res && res.status === 200 && setCstmrs([...res.result]);
      setLoader(false);
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddEdit = (id) => {
    navigate(`/customer_form/${id || ""}`);
  };

  const handleView = (id) => {
    navigate(`/view_customer/${id}`);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure!",
      subTitle: "You want to delete this customer profile?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res.msg,
            });
            setCstmrs((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res.msg,
            });
          }
        };
        API(controller.Customer).Delete(id, onComplete);
      },
    });
  };

  const ActionComp = (val) => (
    <div className="border !border-gray-100 flex gap-2 p-[3px] shadow-sm rounded-[12px] w-fit">
      <Tooltip title="View">
        <IconButton
          onClick={() => handleView(val.id)}
          size="small"
          color="primary"
        >
          <VisibilityRounded className="!text-[18px]" />
        </IconButton>
      </Tooltip>
      {access?.customer?.edit && (
        <Tooltip title="Edit">
          <IconButton
            onClick={() => handleAddEdit(val.id)}
            size="small"
            color="primary"
          >
            <EditRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
      {access?.customer?.delete && (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDlt(val.id)}
            size="small"
            color="error"
          >
            <ClearRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
  const HeaderComp = () =>
    access?.customer?.create && (
      <Button onClick={() => handleAddEdit()}>Add Customer</Button>
    );

  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "cstmr", label: "Customer" },
          { id: "contact", label: "contact" },
          { id: "credit", label: "Store Credit" },
          { id: "cardGroup", label: "Card / Group" },
          { id: "actions", label: "Actions" },
        ]}
        tblData={cstmrs.map((j) => {
          return {
            ...j,
            cstmr: (
              <div className="flex gap-[15px] items-center mb-[5px] mt-[5px]">
                <Avatar className="bg-primary" src={j.photo} />
                <div className="grid">
                  <span className="">{j.firstName + " " + j.lastName}</span>
                  <span className="fs-12">{j.cstmrCode + " | " + j.phone}</span>
                </div>
              </div>
            ),
            credit: formatPrice(j.storeCredit),
            contact: (
              <div className="grid">
                {j.email && (
                  <a
                    className="text-[14px] primary-color cursor-pointer mb-[3px]"
                    href={`mailto:${j.email}`}
                  >
                    ✉️ {j.email}
                  </a>
                )}
                <a
                  className="text-[14px] primary-color cursor-pointer"
                  href={`tel:1955206146`}
                >
                  📞 {j.phone}
                </a>
              </div>
            ),
            cardGroup: (
              <div className="grid">
                <span className="text-[14px] text-gray-500 cursor-pointer">
                  Has card:{" "}
                  <span className="font-medium">
                    {j.cardNumber ? "Yes" : "No"}
                  </span>
                </span>
                <span className="text-[12px] font-medium text-gray-500 cursor-pointer">
                  Group:{" "}
                  <span className="font-medium">
                    {j.cstmrGroup && j.cstmrGroup.name}
                  </span>{" "}
                </span>
              </div>
            ),
          };
        })}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Customers;
